import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress a known Recharts dev-only spurious warning. `<ResponsiveContainer>`
// initialises its internal `containerWidth`/`containerHeight` state to -1 and
// logs a warning on its very first render, before its ResizeObserver has fired.
// The chart re-renders with real dimensions immediately after — the noise is
// harmless but pollutes the console (see recharts/recharts#729, #3543).
if (typeof window !== "undefined") {
  const origWarn = console.warn.bind(console);
  console.warn = (...args) => {
    const first = args[0];
    if (typeof first === "string"
        && first.includes("width(-1) and height(-1) of chart should be greater than 0")) {
      return;
    }
    origWarn(...args);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
